import { Tooltip, TooltipProps, withStyles } from '@material-ui/core';
import React from 'react';

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        display: 'inline-flex',
        padding: '6px 10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '8px',
        background: theme.palette.primary.background,
        boxShadow: '2px 2px 4px 0px rgba(0, 0, 0, 0.19)',
        color: theme.palette.primary.main,
        fontFamily: 'Noto Sans',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '150%',
    },
}))(Tooltip);

const DarkTooltip = withStyles((theme) => ({
    tooltip: {
        display: 'inline-flex',
        padding: '6px 10px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        borderRadius: '8px',
        background: theme.palette.primary.main,
        boxShadow: '2px 2px 4px 0px rgba(0, 0, 0, 0.19)',
        color: theme.palette.primary.background,
        fontFamily: 'Noto Sans',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '150%',
    },
}))(Tooltip);

interface CustomTooltipProps extends Omit<TooltipProps, 'title'> {
    title: TooltipProps['title'];
    variant?: 'light' | 'dark';
    children: React.ReactElement;
    placement?: TooltipProps['placement'];
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
    title,
    variant = 'light',
    children,
    placement = 'top',
    ...props
}) => {
    if (variant === 'dark') {
        return (
            <DarkTooltip title={title} placement={placement} {...props}>
                {children}
            </DarkTooltip>
        );
    }
    return (
        <LightTooltip title={title} placement={placement} {...props}>
            {children}
        </LightTooltip>
    );
};

export default CustomTooltip;
